// extracted by mini-css-extract-plugin
export var linkHeader = "styles-module__linkHeader___wcT9l";
export var buttonHeader = "styles-module__buttonHeader___wecxE";
export var dropdownLink = "styles-module__dropdownLink___j8dMr";
export var expandMore = "styles-module__expandMore___mjhF1";
export var expandMoreIsOpen = "styles-module__expandMoreIsOpen___aaxeT";